import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import appearance from './appearance';
import filters from './filters';
import server from './server';
import session from './session';
import support from './support';

export default function createRootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    appearance,
    session,
    filters,
    server,
    support,
  });
}
